import moment from 'moment';

export default {
    methods: {
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        validMobileNumber(phone){
            if(phone.length < 8){
                return false;
            }
            return this.isNumeric(phone);
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
            } else {
              return true;
            }
        },

        arraysEqual(a, b) {
            if (a === b) return true;
            if (a.length !== b.length) return false;
          
            for (var i = 0; i < a.length; ++i) {
              if (a[i] !== b[i]) return false;
            }
            return true;
        },

        onlyAlpha(str) {
          // const rx = !/^[a-zA-Z]*$/;
          if(str.trim() == '') return false;
          
          return /^[a-zA-Z\s]*$/.test(str);
        },

        formatDate(date, format = 'YYYY-MM-DD') {
          return moment(date).format(format);
        },

        filterCountry(item, queryText){
          return item.Name.toLocaleLowerCase().includes(queryText.toLocaleLowerCase())
              ||  item.MobileCode.toString().includes(queryText.toLocaleLowerCase())

        },

        tConvert (time) {
          // Check correct time format and split into components
          time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
        
          if (time.length > 1) { // If time format correct
            time = time.slice (1);  // Remove full string match value
            time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
          }
          return time.join (''); // return adjusted time or original string
        }
    }
}